import Vue from 'vue'
import Router from 'vue-router'
import store from '../store';

Vue.use(Router)

const router = new Router({
    routes: [
        {
            path: '/',
            name: 'home',
            component: require('@/pages/Home'),
            meta: {
                access: 'all',
                layout: false
            }
        },

        {
            path: '/reservations',
            name: 'reservations',
            component: require('@/pages/reservations/Reservations')
        },

        {
            path: '/reservations/new',
            name: 'reservations.create',
            component: require('@/pages/reservations/Create')
        },

        {
            path: '/reservations/grouped',
            name: 'reservations.grouped',
            component: require('@/pages/reservations/GroupedInvoice')
        },

        {
            path: '/breakfasts',
            name: 'breakfasts',
            component: require('@/pages/breakfasts/Breakfasts')
        },

        {
            path: '/cleaning',
            name: 'cleaning',
            component: require('@/pages/cleaning/Cleaning')
        },

        {
            path: '/reporting',
            name: 'reporting',
            component: require('@/pages/reporting/Reporting')
        },

        {
            path: '/reporting/daily',
            name: 'reporting.daily',
            component: require('@/pages/reporting/DailyReport')
        },

        {
            path: '/statistics',
            name: 'statistics',
            component: require('@/pages/statistics/Statistics')
        },

        // Products
        {
            path: '/products',
            name: 'products',
            component: require('@/pages/products/Products')
        },

        {
            path: '/products/:id',
            name: 'products.view',
            component: require('@/pages/products/View')
        },

        // Rooms
        {
            path: '/rooms',
            name: 'rooms',
            component: require('@/pages/rooms/Rooms')
        },
        {
            path: '/rooms/available',
            name: 'rooms.available',
            component: require('@/pages/rooms/Available')
        },
        {
            path: '/rooms/:id',
            name: 'rooms.view',
            component: require('@/pages/rooms/View')
        },

        {
            path: '/settings',
            name: 'settings',
            component: require('@/pages/settings/Settings')
        },

        // Reservations
        {
            path: '/reservations/:id',
            name: 'reservations.view',
            component: require('@/pages/reservations/View')
        },


        {
            path: '/login',
            name: 'login',
            component: require('@/pages/auth/Login'),
            meta: {
                access: 'all',
                layout: false
            }
        },
    ]
})

// Security
router.beforeEach((to, from, next) => {
    const identity = store.state.auth.identity

    if (!identity && to.matched.length) {
        const match = to.matched[0]

        if (!match.meta.access || match.meta.access !== 'all') {
            const query = (!identity) ? {redirect: to.fullPath} : {}

            next({
                path: '/login',
                query: query
            })

            return
        }
    }

    next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js